// extracted by mini-css-extract-plugin
export var card = "_k5-5";
export var cardSelected = "_k5-4";
export var image = "_k5-3";
export var modal = "_k5-0";
export var modalContent = "_k5-1";
export var table = "_k5-2";